"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkBankAccountSchema = void 0;
const yup = __importStar(require("yup"));
const BSB_LENGTH = "BSB must be exactly 6 digits";
exports.LinkBankAccountSchema = yup.object().shape({
    linkUsing: yup.string().required("Please choose link method"),
    accountName: yup.string().when("linkUsing", {
        is: "Account details",
        then: yup.string().required("Please enter the Account name").min(2, "Account name should be at least 2 characters"),
    }),
    bsb: yup.string().when("linkUsing", {
        is: "Account details",
        then: yup
            .string()
            .required("Please enter the BSB")
            .min(6, BSB_LENGTH)
            .max(6, BSB_LENGTH)
            .matches(/^[0-9]+$/, "BSB must only contain numbers"),
    }),
    accountNumber: yup.string().when("linkUsing", {
        is: "Account details",
        then: yup
            .string()
            .required("Please enter the Account number")
            .min(6, "Account number should be at least 6 digits")
            .matches(/^[0-9]+$/, "Account number must only contain numbers"),
    }),
    payId: yup.string().when("linkUsing", {
        is: "PayID",
        then: yup
            .string()
            .required("Please enter the PayID")
            .when("payIdType", {
            is: "ABN",
            then: yup.string().matches(/^[0-9]{11}$/, "ABN must be 11 digits"),
        })
            .when("payIdType", {
            is: "Email",
            then: yup.string().email("Please enter a valid email address"),
        })
            .when("payIdType", {
            is: "PhoneNumber",
            then: yup.string().matches(/^(04)[0-9]{8}$/, "Phone number must be 10 digits and start with 04"),
        })
            .when("payIdType", {
            is: "OrganisationId",
            then: yup.string().matches(/^[0-9]{9}$/, "Organisation ID must be 9 digits"),
        })
            .when("payIdType", {
            is: "ACN",
            then: yup.string().matches(/^[0-9]{9}$/, "ACN must be 9 digits"),
        }),
    }),
    payIdAccountName: yup.string().when("linkUsing", {
        is: "PayID",
        then: yup
            .string()
            .required("Please enter the PayID Account name")
            .min(2, "Account name should be at least 2 characters"),
    }),
    payIdType: yup
        .string()
        .oneOf(["ABN", "Email", "PhoneNumber", "OrganisationId", "ACN"])
        .when("linkUsing", {
        is: "PayID",
        then: yup
            .string()
            .required("Please choose the PayID type")
            .oneOf(["ABN", "Email", "PhoneNumber", "OrganisationId", "ACN"]),
    }),
});
//# sourceMappingURL=LinkBankAccountSchema.js.map